import routes from './routes';
import sideMenuItem from './sideMenu';

export default (app) => {
    app.routes.addMany(routes(app));
    app.sideMenuItems.addItem('customers', sideMenuItem(app));
};
